<template>
	<div class="message" v-bind:style="{color: text_color, borderColor: border_color, backgroundColor: background_color }">
    <span class="text">
		<icon :name="icon_name" scale="1" :color="icon_color"></icon>&emsp;
      {{ text }}
    </span>
<!--
		<span class="close"
			  @click="closeMessage">
    </span>
    -->
	</div>
</template>

<script>
    export default {
        name: 'message',

        props: {
            icon_name: {type: String, default: "plus-circle"},
            text: {type: String, default: "message"},
            icon_color: {type: String, default: "black"},
            text_color: {type: String, default: "black"},
            border_color: {type: String, default: "black"},
            background_color: {type: String, default: "white"},

        },

        methods: {
            closeMessage () {
                this.$emit('closeMessage')
            }
        }
    }
</script>

<style lang="scss">
	@import '../scss/_variables.scss';
	@import '../scss/_functions.scss';

	.message {
		width: fit-content;
		border: {
			// color: red;
			radius: $border-radius;
			style: dashed;
			width: 1px;
		}
		box-shadow: $box-shadow;
		// color: darkred;
		display: flex;
		font: {
			family: $sans-serif;
			size: .9rem;
			weight: 500;
			style: italic;
		}
		justify-content: space-between;
		margin: {
			bottom: 1rem;
			left: auto;
			right: 0;
			top: 1rem;
		}
		padding: {
			bottom: .75rem;
			left: .75rem;
			right: .75rem;
			top: .75rem;
		}

		.text {
			flex: 1;
		}

		.close {
			background: {
				image: url("../assets/close.svg");
				position: 95%;
				repeat: no-repeat;
				size: 22px;
			}
			cursor: pointer;
			width: 22px;
		}
	}
</style>



// WEBPACK FOOTER //
// Message.vue?2c9ba621